import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  getDiet,
  createDiet,
  updateDiet,
  deleteDiet,
} from "../../actions/dietActions";
// --- NEW IMPORTS ---
import {
  listDietTemplates,
  deleteDietTemplate,
  createDietTemplate,
  updateDietTemplate,
  getDietTemplateById,
} from "../../actions/dietTemplateAction";
import { DIET_TEMPLATE_RESET, DIET_TEMPLATE_DETAILS_RESET } from "../../actions/types";

const DietCharts = () => {
  const dispatch = useDispatch();
  const { dietList, hospitalID } = useSelector((state) => state.diet);

  // --- TEMPLATE REDUX STATE ---
 const { 
  templates, 
  loading,          // ← Yeh add karein (List loading ke liye)
  success: templateSuccess, 
  templateDetails, 
  loadingDetails, 
  error             // ← Yeh add karein (Error messages ke liye)
} = useSelector((state) => state.dietTemplates);

  const [activeTab, setActiveTab] = useState("list");
  const [selectedDiet, setSelectedDiet] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  // Template Specific States
  const [showTemplateViewModal, setShowTemplateViewModal] = useState(false);
  const [isEditingTemplate, setIsEditingTemplate] = useState(false);
  const [templateFormData, setTemplateFormData] = useState({
    id: "",
    template_name: "",
    note: "",
    diet_ids: [],
  });

  const [editingMealIndex, setEditingMealIndex] = useState(null);
  const [newDiet, setNewDiet] = useState({
    title: "",
    diet_type: "Veg",
    description: "",
    status: "Active",
    meals: [],
  });

  const [currentMeal, setCurrentMeal] = useState({
    meal_type: "",
    food_items: "",
    instructions: "",
  });

  // --- INITIAL LOAD ---
  useEffect(() => {
    dispatch(getDiet());
    dispatch(listDietTemplates({ hospital_id: hospitalID }));
  }, [dispatch, hospitalID]);

  // --- AUTO REFRESH AFTER TEMPLATE SAVE ---
  useEffect(() => {
    if (templateSuccess) {
      setShowTemplateViewModal(false);
      setActiveTab("templates"); // Refresh ke baad templates tab par bheje
      dispatch({ type: DIET_TEMPLATE_RESET });
      dispatch(listDietTemplates({ hospital_id: hospitalID }));
      alert("Diet Template saved successfully!");
    }
  }, [templateSuccess, dispatch, hospitalID]);

  // --- TEMPLATE HANDLERS ---
  const resetTemplateForm = () => {
    setTemplateFormData({ id: "", template_name: "", note: "", diet_ids: [] });
    setIsEditingTemplate(false);
  };

  const handleToggleDietInTemplate = (id) => {
    const currentIds = templateFormData.diet_ids || [];
    const targetId = Number(id);
    const isSelected = currentIds.includes(targetId);

    setTemplateFormData({
      ...templateFormData,
      diet_ids: isSelected 
        ? currentIds.filter(dId => dId !== targetId) 
        : [...currentIds, targetId]
    });
  };

  const handleEditTemplate = (temp) => {
    setIsEditingTemplate(true);
    setTemplateFormData({
      id: temp.id,
      template_name: temp.template_name,
      note: temp.note,
      diet_ids: temp.diet_plans ? temp.diet_plans.map(dp => Number(dp.diet_id)) : []
    });
    setActiveTab("createTemplate");
  };

  const handleSaveTemplate = () => {
    if (!templateFormData.template_name) return alert("Template name required");
    const payload = {
      template_name: templateFormData.template_name,
      note: templateFormData.note,
      diet_ids: templateFormData.diet_ids,
      hospital_id: hospitalID,
      status: "Active"
    };

    if (isEditingTemplate) {
      payload.id = templateFormData.id;
      dispatch(updateDietTemplate(payload));
    } else {
      dispatch(createDietTemplate(payload));
    }
  };

  // --- PRINT TEMPLATE LOGIC ---
  const handlePrintTemplate = () => {
    const data = templateDetails?.data?.[0] || templateDetails;
    if (!data) return;
    const printWindow = window.open("", "_blank");
    const plansHtml = data.diet_plans?.map((plan, idx) => `
      <div style="margin-bottom: 25px; break-inside: avoid; border: 1px solid #eee; padding: 15px;">
        <h3 style="color: #00acc1; margin-top: 0;">${idx + 1}. ${plan.title}</h3>
        <p style="font-size: 13px;"><b>Type:</b> ${plan.diet_type} | ${plan.description}</p>
        <table style="width: 100%; border-collapse: collapse;">
          ${plan.meals.map(m => `
            <tr>
              <td style="border: 1px solid #eee; padding: 8px; width: 30%; background: #f9f9f9;"><b>${m.meal_type}</b></td>
              <td style="border: 1px solid #eee; padding: 8px;">${m.food_items}<br/><small>${m.instructions || ""}</small></td>
            </tr>
          `).join('')}
        </table>
      </div>
    `).join('');

    printWindow.document.write(`<html><body style="font-family: sans-serif; padding: 20px;">
      <h1 style="text-align:center;">${data.template_name}</h1>
      <p style="text-align:center; font-style: italic;">${data.note || ""}</p>
      <hr/>${plansHtml}
      <script>setTimeout(() => { window.print(); window.close(); }, 750);</script>
    </body></html>`);
    printWindow.document.close();
  };

  // --- EXISTING DIET HANDLERS ---
   const handleEditSetup = (diet) => {
    setIsEditing(true);
    setEditId(diet.id || diet._id);
    setNewDiet({
      title: diet.title,
      diet_type: diet.diet_type,
      description: diet.description,
       status: diet.status || "Active",
      meals: diet.meals || [],
    });
    setActiveTab("create");
  };
  const handleToggleDietStatus = (diet) => {
  const newStatus = diet.status === "Active" ? "Inactive" : "Active";
  const payload = {
    id: diet.id,
    status: newStatus,
    title: diet.title, // Existing fields bhej rahe hain taaki validation fail na ho
    hospitalID: hospitalID
  };
  dispatch(updateDiet(payload)).then(() => {
    dispatch(getDiet()); // List refresh karein
  });
};

// 2. Diet Template Status Toggle
const handleToggleTemplateStatus = (temp) => {
  const newStatus = temp.status === "Active" ? "Inactive" : "Active";
  const payload = {
    id: temp.id,
    status: newStatus,
    template_name: temp.template_name,
    hospital_id: hospitalID
  };
  dispatch(updateDietTemplate(payload)).then(() => {
    dispatch(listDietTemplates({ hospital_id: hospitalID })); // List refresh karein
  });
};
  const handleAddOrUpdateMeal = () => {
    if (!currentMeal.meal_type || !currentMeal.food_items)
      return alert("Please fill meal type and food items");
    if (editingMealIndex !== null) {
      const updatedMeals = [...newDiet.meals];
      updatedMeals[editingMealIndex] = currentMeal;
      setNewDiet({ ...newDiet, meals: updatedMeals });
      setEditingMealIndex(null);
    } else {
      setNewDiet({ ...newDiet, meals: [...newDiet.meals, { ...currentMeal }] });
    }
    setCurrentMeal({ meal_type: "", food_items: "", instructions: "" });
  };

  const handleSaveDiet = () => {
    if (!newDiet.title) return alert("Plan Title is required");
    const payload = { ...newDiet, hospitalID: hospitalID };
    if (isEditing) {
      payload.id = editId;
      dispatch(updateDiet(payload)).then(() => { alert("Diet Plan Updated!"); resetForm(); });
    } else {
      dispatch(createDiet(payload)).then(() => { alert("Diet Plan Created!"); resetForm(); });
    }
  };

  const resetForm = () => {
    setNewDiet({ title: "", diet_type: "Veg", description: "",    status: "Active", meals: [] });
    setCurrentMeal({ meal_type: "", food_items: "", instructions: "" });
    setEditingMealIndex(null);
    setIsEditing(false);
    setEditId(null);
    setActiveTab("list");
    dispatch(getDiet());
  };

  return (
    <div className="appointments">
      <div className="page-header filter-bar rounded no-print">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="page-title">Diet Management</h4>
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/doctor/dashboard">Dashboard</Link></li>
              <li className="breadcrumb-item active">Diet Plans</li>
            </ul>
          </div>
        </div>
      </div>

      {/* --- UPDATED NAV TABS --- */}
      <ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded mt-4 no-print">
        <li className="nav-item">
          <button className={`nav-link ${activeTab === "templates" ? "active" : ""}`} onClick={() => setActiveTab("templates")}>
            Diet Templates ({templates?.length || 0})
          </button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === "list" ? "active" : ""}`} onClick={() => setActiveTab("list")}>
            Individual Plans ({dietList?.length || 0})
          </button>
        </li>
      </ul>

      <div className="tab-content mt-3">
        
        {/* --- TAB: TEMPLATES LIST --- */}
        {activeTab === "templates" && (
          <div className="row">
            <div className="col-12 mb-3 text-end">
              <button className="btn btn-info rounded-pill" onClick={() => { resetTemplateForm(); setActiveTab("createTemplate"); }}>
                + Create New Template
              </button>
            </div>
   {templates?.map((temp) => (
  <div className="col-md-6 col-lg-4 mb-4" key={temp.id}>
    <div className={`card h-100 shadow-sm border-0 ${temp.status === 'Inactive' ? 'opacity-75' : ''}`}>
      <div className="card-body d-flex flex-column">
        

        <h5 className="fw-bold text-info mb-1">{temp.template_name}</h5>
        <p className="text-muted small mb-3">{temp.note || "No notes added"}</p>
           <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="form-check form-switch mb-0">
            <input 
              className="form-check-input cursor-pointer" 
              type="checkbox" 
              checked={temp.status === "Active"} 
              onChange={() => handleToggleTemplateStatus(temp)}
              id={`tempSwitch${temp.id}`}
            />
            <label className={`form-check-label small fw-bold ml-3 ${temp.status === 'Active' ? 'text-success' : 'text-danger'}`} htmlFor={`tempSwitch${temp.id}`}>
              {temp.status}
            </label>
          </div>
          {/* <span className={`badge ${temp.status === 'Active' ? 'bg-success-light' : 'bg-danger-light text-danger'}`}>
            Template
          </span> */}
        </div>
                    <div className="mt-auto pt-3 border-top">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="badge bg-info-light">{temp.diet_plans?.length || 0} Plans Included</span>
                        <div className="d-flex gap-1">
                          <button className="btn btn-sm btn-info" onClick={() => { dispatch(getDietTemplateById(temp.id)); setShowTemplateViewModal(true); }}><i className="fas fa-eye"></i></button>
                          <button className="btn btn-sm btn-warning text-white" onClick={() => handleEditTemplate(temp)}><i className="fas fa-edit"></i></button>
                          <button className="btn btn-sm btn-danger" onClick={() => { if(window.confirm("Delete template?")) dispatch(deleteDietTemplate(temp.id)) }}><i className="fas fa-trash"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* --- TAB: CREATE TEMPLATE (DESIGNER) --- */}
        {activeTab === "createTemplate" && (
          <div className="card shadow-sm border-0">
            <div className="card-header bg-info text-white fw-bold d-flex justify-content-between">
              <span>{isEditingTemplate ? "Edit" : "Design"} Diet Template</span>
              <button className="btn-close btn-close-white" onClick={() => setActiveTab("templates")}></button>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6"><label className="fw-bold">Template Name</label>
                  <input type="text" className="form-control" value={templateFormData.template_name} onChange={(e) => setTemplateFormData({...templateFormData, template_name: e.target.value})} placeholder="e.g. Elderly Diabetes Plan" />
                </div>
                <div className="col-md-12 mt-2"><label className="fw-bold">Note for Patient</label>
                  <textarea className="form-control" value={templateFormData.note} onChange={(e) => setTemplateFormData({...templateFormData, note: e.target.value})} rows="2" />
                </div>
              </div>
              <h6 className="fw-bold mt-4">Select Individual Plans to Bundle:</h6>
              <div className="row border p-2 rounded" style={{maxHeight: '300px', overflowY: 'auto', background: '#fcfcfc'}}>
                {dietList?.map(diet => (
                  <div className="col-md-4 mb-2" key={diet.id}>
                    <div className={`p-2 border rounded cursor-pointer ${templateFormData.diet_ids.includes(diet.id) ? 'bg-info-light border-info' : ''}`} onClick={() => handleToggleDietInTemplate(diet.id)}>
                      <input type="checkbox" checked={templateFormData.diet_ids.includes(diet.id)} readOnly className="me-2" />
                      {diet.title} <small className="text-muted">({diet.diet_type})</small>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-end mt-4">
                <button className="btn btn-secondary me-2 rounded-pill px-4" onClick={() => setActiveTab("templates")}>Cancel</button>
                <button className="btn btn-success rounded-pill px-5" onClick={handleSaveTemplate}>Save Template</button>
              </div>
            </div>
          </div>
        )}

        {/* TAB: INDIVIDUAL LIST VIEW */}
        {activeTab === "list" && (
          <div className="row">
            <div className="col-12 mb-3 text-end">
              <button className="btn btn-info shadow-sm rounded-pill text-white" onClick={() => { resetForm(); setActiveTab("create"); }}>
                <i className="fas fa-plus me-1"></i> Create New Plan
              </button>
            </div>
           {dietList?.map((diet) => (
  <div className="col-md-6 col-lg-4 mb-4" key={diet.id}>
    <div className={`card h-100 shadow-sm border-0 ${diet.status === 'Inactive' ? 'opacity-75' : ''}`}>
      <div className="card-body d-flex flex-column">
        
        {/* TOP STATUS BAR */}
     

        <h5 className="fw-bold text-info mb-1">{diet.title}</h5>
        <p className="text-muted small mb-3">{diet.description}</p>
        
                 <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="form-check form-switch mb-0">
            <input 
              className="form-check-input cursor-pointer" 
              type="checkbox" 
              checked={diet.status === "Active"} 
              onChange={() => handleToggleDietStatus(diet)}
              id={`dietSwitch${diet.id}`}
            />
            <label className={`form-check-label small fw-bold ml-3 ${diet.status === 'Active' ? 'text-success' : 'text-danger'}`} htmlFor={`dietSwitch${diet.id}`}>
              {diet.status}
            </label>
          </div>
          <span className={`badge ${diet.diet_type === 'Veg' ? 'bg-success' : 'bg-danger'}`}>
            {diet.diet_type}
          </span>
        </div>
                    <div className="mt-auto pt-3 border-top">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="badge bg-info-light">{diet.meals?.length || 0} Meals</span>
                        <div className="d-flex gap-1">
                          <button className="btn btn-sm btn-info" onClick={() => setSelectedDiet(diet)}><i className="fas fa-eye"></i></button>
                          <button className="btn btn-sm btn-warning text-white" onClick={() => { setIsEditing(true); setEditId(diet.id); handleEditSetup(diet); }}><i className="fas fa-edit"></i></button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => { if(window.confirm("Delete plan?")) dispatch(deleteDiet(diet.id)).then(() => dispatch(getDiet())) }}><i className="fas fa-trash"></i></button> */}
                    
<button 
  className="btn btn-sm btn-danger" 
  onClick={() => { 
    if(window.confirm("Delete plan?")) {
      // Yahan hum id aur hospitalID dono bhej rahe hain
      dispatch(deleteDiet({ id: diet.id, hospitalID: hospitalID }))
        .then(() => dispatch(getDiet())); 
    }
  }}
>
  <i className="fas fa-trash"></i>
</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* TAB: CREATE/EDIT INDIVIDUAL PLAN */}
        {activeTab === "create" && (
          <div className="card shadow-sm border-0">
            <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
              <span className="fw-bold">{isEditing ? "Update Diet Plan" : "Plan Designer"}</span>
              <button className="btn-close btn-close-white" onClick={() => setActiveTab("list")}></button>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-8 mb-3">
                  <label className="fw-bold">Plan Title</label>
                  <input type="text" className="form-control" value={newDiet.title} onChange={(e) => setNewDiet({ ...newDiet, title: e.target.value })} placeholder="e.g. Keto Meal Plan" />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="fw-bold">Diet Type</label>
                  <select className="form-select" value={newDiet.diet_type} onChange={(e) => setNewDiet({ ...newDiet, diet_type: e.target.value })}>
                    <option value="Veg">Veg</option>
                    <option value="Non-Veg">Non-Veg</option>
                    <option value="Vegan">Vegan</option>
                  </select>
                </div>
                <div className="col-md-4 mb-3">
  <label className="fw-bold">Plan Status</label>
  <select 
    className={`form-select fw-bold ${newDiet.status === 'Active' ? 'text-success' : 'text-danger'}`} 
    value={newDiet.status} 
    onChange={(e) => setNewDiet({ ...newDiet, status: e.target.value })}
  >
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>
</div>
                <div className="col-md-12 mb-3">
                  <label className="fw-bold">Short Description</label>
                  <textarea className="form-control" value={newDiet.description} onChange={(e) => setNewDiet({ ...newDiet, description: e.target.value })} rows="1"></textarea>
                </div>
              </div>

              <div className={`p-3 rounded border mb-4 ${editingMealIndex !== null ? 'border-warning bg-warning-light ' : 'bg-light'}`}>
                <h6 className="fw-bold mb-3">{editingMealIndex !== null ? "Edit Selected Meal" : "Add Meal"}</h6>
                <div className="row g-2">
                  <div className="col-md-3">
                    <select className="form-select" value={currentMeal.meal_type} onChange={(e) => setCurrentMeal({ ...currentMeal, meal_type: e.target.value })}>
                        <option value="">Meal Time</option>
                        <option value="Breakfast">Breakfast</option>
                        <option value="Mid-Morning">Mid-Morning</option>
                        <option value="Lunch">Lunch</option>
                        <option value="Evening Snack">Evening Snack</option>
                        <option value="Dinner">Dinner</option>
                    </select>
                  </div>
                  <div className="col-md-4"><input type="text" className="form-control" placeholder="Food Items" value={currentMeal.food_items} onChange={(e) => setCurrentMeal({ ...currentMeal, food_items: e.target.value })} /></div>
                  <div className="col-md-3"><input type="text" className="form-control" placeholder="Instructions" value={currentMeal.instructions} onChange={(e) => setCurrentMeal({ ...currentMeal, instructions: e.target.value })} /></div>
                  <div className="col-md-2"><button className={`btn w-100 ${editingMealIndex !== null ? 'btn-warning text-white' : 'btn-info'}`} onClick={handleAddOrUpdateMeal}>{editingMealIndex !== null ? "Update" : "+ Add"}</button></div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light"><tr><th>Time</th><th>Details</th><th className="text-center">Action</th></tr></thead>
                  <tbody>
                    {newDiet.meals.map((m, index) => (
                      <tr key={index} className={editingMealIndex === index ? 'table-info' : ''}>
                        <td className="fw-bold">{m.meal_type}</td>
                        <td>{m.food_items}<br/><small className="text-muted">{m.instructions}</small></td>
                        <td className="text-center">
                          <button className="btn btn-sm text-warning me-2" onClick={() => { setCurrentMeal(m); setEditingMealIndex(index); window.scrollTo(0, 200); }}><i className="fas fa-edit"></i></button>
                          <button className="btn btn-sm text-danger" onClick={() => setNewDiet({...newDiet, meals: newDiet.meals.filter((_,i)=>i!==index)})}><i className="fas fa-trash"></i></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="text-end mt-4">
                <button className="btn btn-secondary rounded-pill px-4 me-2" onClick={() => setActiveTab("list")}>Cancel</button>
                <button className="btn btn-success rounded-pill px-5" onClick={handleSaveDiet}>{isEditing ? "Update Plan" : "Save Plan"}</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* --- VIEW TEMPLATE MODAL --- */}
{/* --- VIEW TEMPLATE MODAL (DIET) --- */}
{showTemplateViewModal && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}>
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content border-0 shadow-lg">
        
        {/* Modal Header */}
        <div className="modal-header bg-info text-white">
          <div className="d-flex align-items-center">
            <i className="fas fa-utensils fa-lg me-2"></i>
            <h5 className="modal-title fw-bold">
              {loadingDetails ? "Fetching Data..." : (templateDetails?.template_name || "View Diet Plan")}
            </h5>
          </div>
          <div className="ms-auto">
            {!loadingDetails && templateDetails && (
              <button className="btn btn-sm btn-light me-2 fw-bold rounded-pill px-3 shadow-sm" onClick={handlePrintTemplate}>
                <i className="fas fa-download me-1"></i> Print Plan
              </button>
            )}
            <button 
              className="btn-close btn-close-white shadow-none" 
              onClick={() => {
                setShowTemplateViewModal(false);
                dispatch({ type: DIET_TEMPLATE_DETAILS_RESET });
              }}
            ></button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="modal-body p-0 bg-light hide-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {loadingDetails ? (
            <div className="text-center py-5">
              <div className="spinner-border text-info" role="status"></div>
              <p className="mt-2 text-muted fw-bold">Compiling your diet plan...</p>
            </div>
          ) : templateDetails ? (
            <div className="p-4">
              {/* Template Summary Card */}
              <div className="card border-0 shadow-sm mb-4 rounded-3 overflow-hidden">
                <div className="card-body bg-white border-start border-info border-5">
                  <h6 className="text-info fw-bold text-uppercase small mb-2">Instructions & Special Notes</h6>
                  <p className="mb-0 text-secondary italic fs-6">
                    <i className="fas fa-info-circle me-2 opacity-50"></i>
                    {templateDetails.note || "Please follow this diet plan consistently for the best results."}
                  </p>
                </div>
              </div>

              {/* Diet Plans Loop */}
              {templateDetails.diet_plans?.map((plan, pIdx) => (
                <div key={pIdx} className="mb-5 animate__animated animate__fadeIn">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow" style={{ width: '40px', height: '40px', flexShrink: 0 }}>
                      <span className="fw-bold">{pIdx + 1}</span>
                    </div>
                    <div>
                      <h4 className="text-dark fw-bold mb-0">{plan.title}</h4>
                      <div className="d-flex gap-2 mt-1">
                        <span className={`badge ${plan.diet_type === 'Veg' ? 'bg-success' : 'bg-danger'} rounded-pill small`}>
                          {plan.diet_type}
                        </span>
                        <span className="text-muted small italic">{plan.description}</span>
                      </div>
                    </div>
                  </div>

                  {/* Meals Grid */}
                  <div className="row g-3">
                    {plan.meals?.map((meal, mIdx) => (
                      <div className="col-lg-6" key={mIdx}>
                        <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden d-flex flex-row" style={{ minHeight: '100px' }}>
                          
                          {/* Left Side: Meal Type */}
                          <div className="bg-info-light d-flex align-items-center justify-content-center border-end" style={{ width: '35%', background: '#e0f7fa' }}>
                            <div className="text-center">
                              <i className="fas fa-clock text-info mb-1"></i>
                              <div className="text-info fw-bold small text-uppercase" style={{ fontSize: '11px' }}>{meal.meal_type}</div>
                            </div>
                          </div>

                          {/* Right Side: Content */}
                          <div className="p-3 position-relative" style={{ width: '65%', background: '#fff' }}>
                            <div className="fw-bold text-dark mb-1" style={{ fontSize: '15px' }}>{meal.food_items}</div>
                            {meal.instructions && (
                              <p className="text-muted mb-0" style={{ fontSize: '12px', borderTop: '1px solid #f0f0f0', paddingTop: '5px' }}>
                                <i className="fas fa-hand-point-right me-1 text-info opacity-50"></i>
                                {meal.instructions}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {pIdx < templateDetails.diet_plans.length - 1 && <hr className="mt-5 opacity-5" />}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
              <p className="h5">No Template data found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

      {/* --- INDIVIDUAL VIEW MODAL --- */}
      {selectedDiet && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0">
              <div className="modal-header bg-info text-white">
                <h5 className="modal-title">View Plan: {selectedDiet.title}</h5>
                <button className="btn-close btn-close-white" onClick={() => setSelectedDiet(null)}></button>
              </div>
              <div className="modal-body p-4 bg-white" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <div className="text-center mb-4"><h2 className="text-info fw-bold">{selectedDiet.title}</h2><span className="badge bg-dark mb-2">{selectedDiet.diet_type} Category</span></div>
                {selectedDiet.meals?.map((meal, idx) => (
                  <div className="d-flex border rounded mb-2 overflow-hidden shadow-sm" key={idx}>
                    <div className="bg-light p-3 fw-bold text-info border-right d-flex align-items-center justify-content-center" style={{ width: "25%" }}>{meal.meal_type}</div>
                    <div className="p-3 bg-white" style={{ width: "75%" }}>
                      <div className="fw-bold h6">{meal.food_items}</div>
                      <div className="text-muted small">{meal.instructions}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .bg-info-light { background-color: #e0f7fa; color: #00838f; padding: 5px 10px; border-radius: 4px; }
        .bg-warning-light { background-color: #fcf8e3; }
        .cursor-pointer { cursor: pointer; }
        /* Custom switch colors */
.form-check-input:checked {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
}

.bg-success-light {
    background-color: rgba(40, 167, 69, 0.1);
    color: #28a745;
}

.bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1);
    color: #dc3545;
}

.opacity-75 {
    opacity: 0.75;
    background-color: #f8f9fa; /* Inactive cards will look slightly grayed out */
}

.cursor-pointer {
    cursor: pointer;
}
      `}</style>
    </div>
  );
};

export default DietCharts;